<template>
    <div class="contentWidth myintro" v-loading="loading">
        <div class="main">
            <img :src="banner" width="1064" style="object-fit: none;" />
            <div class="boxShadow card">
                <div class="toolbar">
                    <div class="toolbar-left" :style="{ visibility: formData.stateDesc || defaultStateObj.name ? 'visible' : 'hidden' }">
                        <span class="tag"></span>
                        <span>信息状态：</span>
                        <el-tag color="#287CF3" effect="dark">{{ formData.stateDesc || defaultStateObj.name }}</el-tag>
                    </div>
                    <el-popover
                        placement="bottom"
                        trigger="click">
                        <div class="right-button" slot="reference">点击查看联系人</div>
                        <div style="width: 200px;">
                            <img :src="qrCode" style="width: 100%;" alt="联系人二维码"/>
                        </div>
                    </el-popover>
                </div>
                <el-form 
                    label-position="left" 
                    label-width="80px" 
                    size="medium" 
                    ref="form"
                    :rules="rules" 
                    :model="formData" 
                    v-loading="loading"
                    :disabled="[3,4].includes(state)"
                >
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="性别"  prop="sex">
                        <el-radio-group v-model="formData.sex">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="2">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="电话"  prop="mobile">
                        <el-input v-model="formData.mobile"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="简历概要"  prop="resumeSummary">
                        <el-input 
                            type="textarea"
                            placeholder="请输入100个左右的字符，描述自己，兜售自己！"
                            v-model="formData.resumeSummary" 
                            :rows="5">
                        </el-input>
                    </el-form-item> -->
                    <ai-control
                        label="简历概要"
                        name="resumeSummary"
                        placeholder="请输入100个左右的字符，描述自己，兜售自己！"
                        v-model="formData.resumeSummary">
                    </ai-control>
                    <div class="footer">
                        <el-button size="medium" @click="onCancel">取消</el-button>
                        <el-button size="medium" type="primary" style="margin-left:16px" @click="onSubmit" :disabled="disabled">提交</el-button>
                    </div>
                </el-form>
                <el-alert
                    title="人才计划门槛"
                    :closable="false"
                    class="memo"
                    type="info">
                    <div style="white-space: pre-line;">{{ memo }}</div>
                </el-alert>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState} from 'vuex'
import {getQrCode,getData,addData,updateData} from '@/api/highTalents'
import { getSystemImage } from '@/api/common'
import AiControl from '@/components/ai-control';
export default {
    name: 'IntroMe',
    components: {AiControl},
    data(){
        return{
            loading:false,
            disabled: false,
            formData:{
                id:'',
                state: 1,
                stateDesc: '',
                name: '',
                mobile:'',
                sex:'',
                resumeSummary: ''
            },
            rules:{
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                ],
                sex: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                resumeSummary: [
                    { required: true, message: '请输入简历概要', trigger: 'blur' }
                ],
            },
            qrCode:'',
            banner: '',
            memo:`专攻高端技术人才精准匹配，助您极速锁定理想职位：

            深度解析行业壁垒： 不止年限，精准评估您在细分赛道的项目影响力、资源整合与战略价值。顶会顶刊一作，大赛获奖
            硬核实力量化呈现： 结合专利/方案盲评/技术攻坚案例，权威验证您的架构能力与技术稀缺性。
            50万+年薪硬门槛： 依托实时薪酬数据库，锁定匹配您稀缺技能组合的基准线，保障竞争力年薪。
            优秀毕业院校：天才少年、科学家、年轻名校PHD
            7天极速智能匹配：

            AI直通隐蔽职位： 解锁未公开的CXO储备岗/核心技术委员会机会。
            90%精准推送： 算法+专属顾问双驱动，72小时内推送高匹配核心岗（限C轮+/行业TOP3/央企战略部门，确保技术决策权/团队规模）。
            直击高管面试： 针对性模拟决策层商业推演。`
        }
    },
    methods:{
        async onSubmit() {
            try {
                await this.$refs.form.validate();
                const method = this.formData.id ? updateData : addData;
                this.loading = true;
                const { state,stateDesc,...rest} = this.formData;
                const {code,data,message} = await method(rest);
                if(code === 200) {
                    this.$message.success('操作成功');
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
                this.fetchData();
            } catch (error) {
                this.loading = false;
                console.error(error);
            }
        },
        async onCancel(){
            this.$router.push('/')
        },
        async fetchData(){
            try{
                this.loading = true;
                const { data = { state:1 },code,message } = await getData();
                if(code == 200){
                    Object.keys(this.formData).forEach(key=>{
                        this.formData[key] = data[key];
                    });
                    if([3,4].includes(data.state)) this.disabled = true;
                }
                else this.$message.error(`获取我的高端人才数据出错:${message}`);
                this.loading = false;
            }
            catch(e){
                console.error("获取我的高端人才介绍出错:",e);
                this.loading = false;
            }
        },
        async fetchQrcode(){
            try{
                const {code,data,message} = await getQrCode();
                if(code == 200){
                    this.qrCode = data;
                }
                else this.$message.error(message || "获取联系人二维码出错");
            }
            catch(e){
                console.error(e);
            }
        }
    },
    computed: {
      ...mapState({
        userInfo:state => state.user.info,
        defaultStateObj: state => {
            console.log('state.dictionaries',state.dictionaries);
            var obj = state.dictionaries.find(x=>x.code == 407);
            return obj && obj.children[0] || {name:''};
        },
      }),
    },
    async created(){
        await this.fetchData();
        await this.fetchQrcode();
        console.log('需要填充吗',this.formData);
        if(!this.formData.name){
            this.formData.name = this.userInfo.name;
        }
        if(!this.formData.mobile){
            this.formData.mobile = this.userInfo.mobile;
        }
        if(!this.formData.sex && this.userInfo.genderName){
            this.formData.sex = this.userInfo.genderName === '男' ? 1 : 2 ;
        }
        getSystemImage(9).then(url=>this.banner = url);
    },
}
</script>
<style lang="less" scoped>
.myintro {
  padding: 20px 0;
  .main{
    width: 1064px;
    margin: 0 auto;
    .card{
        margin-top: 15px;
        background-color: #fff;
        padding: 24px 24px 10px 24px;
        .toolbar{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .toolbar-left{
                display: flex;
                align-items: center;
                .tag{
                    width: 4px;
                    height: 12px;
                    background: #287CF3;
                    border-radius: 2px 2px 2px 2px;
                    margin-right: 12px;
                }
            }
            .right-button{
                width: 124px;
                height: 36px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #287CF3;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #287CF3;
                font-size: 14px;
                cursor: pointer;
            }
            margin-bottom: 22px;
        }
        .footer{
            margin-top: 22px;
            border-top: 1px solid rgba(0,0,0,0.06);
            text-align: right;
            padding-top: 10px;
        }
        .memo{
            margin: 20px 0;
        }
    }
  }
}
</style>